import { BrokerExtensions } from "plugins/core";
import { ExportToPdfHandler } from "./handler";
import { ExportPdf } from "./request";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import "./export-pdf-modal/export-pdf-modal";

let request: BrokerDisposableHandler;

export const bootstrapExportPdf = (broker: BrokerExtensions) => {
  request = broker.registerRequest(ExportPdf, ExportToPdfHandler);
};

export const teardownExportPdf = () => {
  request?.dispose();
};
